export const DEFAULT_DATE_FORMAT = "dd/MM/yyyy";
